import {
  getPresentDayContentBoxes,
  sortContentBoxesByClassOrder,
} from "utils/contentBoxDisplayOrder";
import {
  doesClassMeetOnCalendarDate,
  resolveLegacyTemplateForDate,
} from "utils/scheduleResolver";
import { getScheduleRuntimeMode } from "utils/scheduleSettings";

export const CONTENT_MANAGER_ALL_CLASSES_ID = "all";

export const isContentManagerAllClassesId = (classId) =>
  String(classId || "") === CONTENT_MANAGER_ALL_CLASSES_ID;

export const doesClassMeetOnSelectedDate = ({
  classItem,
  userSettings = {},
  activeDate,
} = {}) => {
  if (!classItem?.classId) return false;

  if (getScheduleRuntimeMode(userSettings) === "calendar") {
    return doesClassMeetOnCalendarDate({
      classId: classItem.classId,
      userSettings,
      activeDate,
    });
  }

  const resolvedSchedule = resolveLegacyTemplateForDate(userSettings, activeDate);
  const scheduleEntry = classItem?.schedule?.[resolvedSchedule?.scheduleKey]?.[resolvedSchedule?.dayName];
  return scheduleEntry?.active === true;
};

export const getContentManagerAllClassesDayBoxGroups = ({
  contentBoxes = [],
  classItem,
  date,
  userSettings = {},
} = {}) => {
  const useActiveDates = userSettings?.useActiveDates === true;
  const contentBoxesOrder = classItem?.contentBoxesOrder || [];

  if (useActiveDates) {
    const dayBoxes = getPresentDayContentBoxes(contentBoxes, {
      date,
      settings: { useActiveDates: true },
      contentBoxesOrder,
      visibleOnly: false,
    });
    return {
      activeBoxes: dayBoxes.filter((box) => box?.show !== false),
      hiddenBoxes: dayBoxes.filter((box) => box?.show === false),
    };
  }

  return {
    activeBoxes: sortContentBoxesByClassOrder(
      contentBoxes.filter((box) => box?.show !== false && box?.active === true),
      contentBoxesOrder
    ),
    hiddenBoxes: sortContentBoxesByClassOrder(
      contentBoxes.filter((box) => box?.show === false || box?.active === false),
      contentBoxesOrder
    ),
  };
};

export const getContentManagerAllClassesDayBoxes = (args) =>
  getContentManagerAllClassesDayBoxGroups(args).activeBoxes;
